import { TAX_RATE } from '@/store/types';

export default {
  data() {
    return {
      priceModel: 0,
    };
  },

  computed: {
    taxRate() {
      const taxState = this.$store.getters[TAX_RATE];
      const taxError = taxState.error;

      if (taxError) {
        this.$message.error(taxError);
      }

      return taxState.value;
    },

    vatValue() {
      return Math.round(this.taxRate * this.priceModel);
    },

    devShare() {
      return Math.ceil(
        0.85 * (this.priceModel - this.vatValue) - this.shaparakFee,
      );
    },

    devShareHighSales() {
      return Math.ceil(
        0.7 * (this.priceModel - this.vatValue) - this.shaparakFee,
      );
    },

    bazaarShare() {
      return Math.floor(0.15 * (this.priceModel - this.vatValue));
    },

    bazaarShareHighSales() {
      return Math.floor(0.3 * (this.priceModel - this.vatValue));
    },

    shaparakFee() {
      if (this.priceModel < 2000) return 0;
      if (this.priceModel <= 6_000_000) return 1200;
      if (this.priceModel >= 200_000_000) return 40000;
      return Math.ceil(this.priceModel * 0.0002);
    },
  },

  created() {
    this.getTaxRate();
  },

  methods: {
    getTaxRate() {
      if (!this.taxRate) {
        this.$store.dispatch(TAX_RATE);
      }
    },
  },
};
